/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import SelectDateFilter from 'modules/common/components/SelectDateFilter';
import PropTypes from 'prop-types';
import withDashboard from '../../../common/hoc/withDashboard';
import MiscellaneousFeesChartComponent from '../components/MiscellaneousFeesChartComponent';
import * as actions from '../action';
import * as c from '../constant';

function MiscellaneousFeesDashboardContainer({ graphStats, getGraphStats }) {
  const renderLegends = dt =>
    dt.map(x => {
      return (
        <div key={x.name} className="legend-item">
          <div
            style={{
              background: `${x.color}`,
              width: 20,
              height: 20,
              marginRight: 20,
            }}
          />
          <div className="legend-text">{x.name}</div>
        </div>
      );
    });

  const handleOnSubmit = data => {
    const args = {
      ...data,
      permit_type: 'Miscellaneous Fees',
    };
    getGraphStats(args);
  };

  useEffect(() => {
    getGraphStats();
  }, []);

  return (
    <div className="dashboard-card">
      <div className="row mb-3">
        <div className="col-12">
          <div className="main-text">Statistics</div>
        </div>
        <div className="col-12">
          <SelectDateFilter onSubmit={handleOnSubmit} />
        </div>
        <div className="col-12">
          <MiscellaneousFeesChartComponent chartData={graphStats} />
        </div>
        <div className="legends-wrapper area px-3 w-100">
          <div
            className="render-chart-legends"
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
          >
            {renderLegends(c.LEGENDS)}
          </div>
        </div>
      </div>
    </div>
  );
}

MiscellaneousFeesDashboardContainer.propTypes = {
  graphStats: PropTypes.instanceOf(Object).isRequired,
  getGraphStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  graphStats: _.get(api, `${c.GET_GRAPH_STATS}.list`) || [],
});

const enhance = _.flowRight([
  withDashboard,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(MiscellaneousFeesDashboardContainer);
